import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormValidationService } from '../dynamic/service/formValidationService';
import { FormValidator } from '../dynamic/service/FormValidator';

@Component({
    selector: 'app-application-ftp',
    templateUrl: './applicationFtp.component.html',
    providers: [
        FormValidationService,
        { provide: FormValidator, useExisting: FormValidationService }
    ],
    styleUrls: ['./applicationFtp.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ApplicationFtpComponent {
    @Input() application: any;
    @Input() applicationType: any;

    constructor() {}
}

